export function detectPlatform() {
    const g = globalThis;
    if (!g.window)
        return 'web';
    const w = g.window;
    if (w.Telegram?.WebApp)
        return 'telegram';
    if (w.WebApp?.initData && !w.Telegram?.WebApp)
        return 'max';
    return 'web';
}
// Server-only helpers (node:crypto) live behind the `@beauty/platform/server`
// entry point so browser bundles never pull Node built-ins into the graph.
//# sourceMappingURL=index.js.map